

























































import {Component} from 'vue-property-decorator'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {formatDate} from "@/utils/formatters";

@Component({})
export default class IzvestajAktivnosti extends mixins(ComponentBaseMixin) {

  report = [];
  isBusySearch = false;
  fromDate = '';
  toDate = '';
  selectedMerchandiser = '';
  merchandisers = [];
  headers = [];

  async created() {
    const {data} = await this.axios.get('/api/GetUsers');
    this.merchandisers = data;
  }

  async mounted() {
    let picker = $('#daterangepicker');
    picker.daterangepicker(
        {
          format: this.$i18n.t('DATE_FORMAT'),
          autoApply: true
        },
    ).data('daterangepicker').setStartDate(new Date());
  }

  async search() {
    if (this.isBusySearch) return;
    this.isBusySearch = true;
    let picker = $('#daterangepicker');
    this.fromDate = picker.data('daterangepicker').startDate.format('YYYY-MM-DD');
    this.toDate = picker.data('daterangepicker').endDate.format('YYYY-MM-DD');
    this.isBusySearch = true;
    try {
      const { data } = await this.axios.get(`/api/GetActivitiesInPeriodReport`, {
        params: {
          fromDate: this.fromDate,
          toDate: this.toDate,
          userId: this.selectedMerchandiser
        }
      });
      this.report = data;
    } catch (e) {
      this.showError('neuspesnoUcitavanjePodataka');
    } finally {
      this.isBusySearch = false;
    }
  }
}
